































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import { QFile } from 'quasar'
import store from 'src/assets/store'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import api from 'src/assets/api/gql'
import rest from 'src/assets/api/rest'
import PersonAvatarUploadStart from 'src/graphql/person/PersonAvatarUploadStart.gql'
import PersonAvatarUploadComplete from 'src/graphql/person/PersonAvatarUploadComplete.gql'
import PersonAvatarDelete from 'src/graphql/person/PersonAvatarDelete.gql'
import MeUpdate from 'src/graphql/person/MeUpdate.gql'

@Component({
  components: {
    PersonAvatar
  }
})
export default class AccountPersonAvatarChange extends Vue {
  person = store.state.person
  loading = false
  image = false
  file: File | null | undefined = null

  @Ref()
  readonly input!: QFile

  @Watch('file')
  async set (file: File | undefined) {
    if (file) {
      this.loading = true
      const reduce = require('image-blob-reduce')()
      const blob = await reduce.toBlob(file, { max: 512 })
      const { data: { personAvatarUploadStart: { jwtToken } } } = await api.query({
        query: PersonAvatarUploadStart,
        variables: {
          input: {
            size: blob.size,
            type: blob.type,
            name: file.name
          }
        }
      })
      const form = new FormData()
      form.append('file', blob, file.name)
      const response = await rest.submit('/api/file/upload', form, jwtToken)
      const { src } = await response.json()
      const { data: { personAvatarUploadComplete } } = await api.mutate({
        query: PersonAvatarUploadComplete,
        variables: {
          input: { src }
        }
      })
      if (personAvatarUploadComplete && personAvatarUploadComplete.person) {
        store.setPerson(personAvatarUploadComplete.person)
      }
      this.loading = false
    }
  }

  async deleteAvatar () {
    this.loading = true
    const { data: { updatePerson } } = await api.mutate({
      query: MeUpdate,
      variables: {
        id: this.person.id,
        data: { avatarUrl: null }
      }
    })
    if (updatePerson && updatePerson.person) {
      store.setPerson(updatePerson.person)
    }
    this.loading = false
  }
}
